/* collection-capsules.js - Collection Capsules ScrollSpy and Navigation Script */

(function () {
  'use strict';

  function initCollectionCapsules(container) {
    if (!container || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    const links = container.querySelectorAll('.capsules__link');
    const currentPath = window.location.pathname;
    const currentHash = window.location.hash;

    // 1. Static active class by pathname/hash matching
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      
      if (href === currentPath && !currentHash) {
        link.classList.add('is-active');
        return;
      }

      try {
        const url = new URL(link.href, window.location.origin);
        if (url.pathname === currentPath) {
          if (currentHash) {
            if (url.hash === currentHash) {
              link.classList.add('is-active');
            }
          } else if (!url.hash && href !== '#' && !href.startsWith('#')) {
            link.classList.add('is-active');
          }
        }
      } catch(e) {}
    });

    const initScrollSpy = () => {
      let currentActiveLink = container.querySelector('.capsules__link.is-active');

      if (currentActiveLink) {
        requestAnimationFrame(() => {
          currentActiveLink.scrollIntoView({ block: 'nearest', inline: 'center' });
        });
      }

      const targets = [];
      const linkMap = new Map();

      links.forEach(link => {
        try {
          const url = new URL(link.href, window.location.origin);
          if (url.hash && (url.pathname === currentPath || url.pathname === '/')) {
            const targetEl = document.querySelector(url.hash);
            if (targetEl) {
              targets.push(targetEl);
              linkMap.set(targetEl, link);
            }
          }
        } catch(e) {}
      });

      if (targets.length > 0) {
        const observerOptions = {
          root: null,
          rootMargin: '-20% 0px -35% 0px',
          threshold: 0
        };

        let activeTarget = null;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              activeTarget = entry.target;
            } else if (activeTarget === entry.target) {
              activeTarget = null;
            }
          });

          const activeLink = activeTarget ? linkMap.get(activeTarget) : null;
          if (activeLink && activeLink !== currentActiveLink) {
            if (currentActiveLink) {
              currentActiveLink.classList.remove('is-active');
            }
            activeLink.classList.add('is-active');
            currentActiveLink = activeLink;
            activeLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }, observerOptions);

        targets.forEach(target => observer.observe(target));

        container.addEventListener('capsules:destroy', () => {
          observer.disconnect();
        }, { once: true });
      }

      let firstLinkIsValid = false;
      if (links.length > 0) {
        const href = links[0].getAttribute('href');
        if (href && href !== '#' && !href.startsWith('#')) {
          try {
            const firstUrl = new URL(links[0].href, window.location.origin);
            if (firstUrl.pathname === currentPath || firstUrl.hash) {
              firstLinkIsValid = true;
            }
          } catch(e) {}
        }
      }

      const handleScroll = () => {
        if (window.scrollY < 120 && firstLinkIsValid) {
          const firstLink = links[0];
          if (currentActiveLink !== firstLink) {
            if (currentActiveLink) {
              currentActiveLink.classList.remove('is-active');
            }
            firstLink.classList.add('is-active');
            currentActiveLink = firstLink;
          }
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      const handleHashChange = () => {
        const hash = window.location.hash;
        if (hash) {
          links.forEach(link => {
            try {
              const url = new URL(link.href, window.location.origin);
              if (url.hash === hash) {
                if (link !== currentActiveLink) {
                  if (currentActiveLink) {
                    currentActiveLink.classList.remove('is-active');
                  }
                  link.classList.add('is-active');
                  currentActiveLink = link;
                  link.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                }
              }
            } catch(e) {}
          });
        }
      };

      window.addEventListener('hashchange', handleHashChange);
      if (currentHash) {
        setTimeout(handleHashChange, 100);
      }

      container.addEventListener('capsules:destroy', () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('hashchange', handleHashChange);
      }, { once: true });
    };

    initScrollSpy();
  }

  function initAllCapsules() {
    const containers = document.querySelectorAll('.capsules');
    containers.forEach(container => {
      initCollectionCapsules(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCapsules);
  } else {
    initAllCapsules();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = document.querySelector(`.capsules[data-section-id="${e.detail.sectionId}"]`);
    if (container) {
      initCollectionCapsules(container);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const container = document.querySelector(`.capsules[data-section-id="${e.detail.sectionId}"]`);
    if (container) {
      container.dispatchEvent(new CustomEvent('capsules:destroy'));
    }
  });

})();
